import { render, staticRenderFns } from "./DashboardControls.vue?vue&type=template&id=2767b99a&"
import script from "./DashboardControls.vue?vue&type=script&lang=ts&"
export * from "./DashboardControls.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardControls.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports